import { render } from "./AddNewGroup.vue?vue&type=template&id=627e08f6"
import script from "./AddNewGroup.vue?vue&type=script&lang=js"
export * from "./AddNewGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__